<template>
  <div class="legend-heatmap">
    <div class="color-bar" v-bind:style="{ 'background': gradient }" />
    <div class="legend-text-container">
      <span class="legend-text top"> 100% </span>
      <span class="legend-text bottom">
        {{ `${threshold * 100}%` }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAnalyzeLegendHeatmap',
  inheritAttrs: false,
  props: {
    /**
     * カラーレンジ
     */
    colorRange: {
      type: Array,
      default: () => [],
    },
    /**
     * 下限閾値
     */
    threshold: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    /**
     * グラデーション
     * @type {String}
     */
    gradient: function () {
      const rgbs = this.colorRange
        .map((color) => `rgb(${color.slice(0, 3).join(',')})`)
        .join(',')
      return `linear-gradient(to top,${rgbs})`
    },
  },
}
</script>

<style lang="scss" scoped>
$-height: 200px;

.legend-heatmap {
  height: $-height;
  font-size: 0.875rem;
  column-gap: 16px;
  display: grid;
  grid-template-columns: max-content max-content;
}

.color-bar {
  width: 24px;
  height: $-height;
}

.legend-text-container {
  height: $-height;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  .legend-text {
    &.top {
      margin-top: -4px;
    }

    &.bottom {
      margin-bottom: -4px;
    }
  }
}
</style>
